import axios from 'axios';
import Urls from '@constants';
import NProgress from 'nprogress/nprogress';
import Notification from '@utils/notification';
import store from '@state/store.js';

const base = axios.create({
	baseURL: Urls.URL_API,
	timeout: 600000,
	headers: {
		Accept: 'application/json',
		'Content-Type': 'application/json'
	}
});

const baseBlob = axios.create({
	baseURL: Urls.URL_API,
	responseType: 'blob'
});

const baseFile = axios.create({
	baseURL: Urls.URL_API,
	headers: { 'Content-Type': 'multipart/form-data' }
});

const interceptorRequest = function(config) {
	if (store.state.oidc && store.state.oidc.access_token) {
		config.headers.Authorization = 'Bearer ' + store.state.oidc.access_token;
	} else if (store.state.token) {
		config.headers.Authorization = 'Bearer ' + store.state.token;
	}
	return config;
};

const interceptorRequestError = function(error) {
	return Promise.reject(error);
};

const catchErrorResponse = function(reject, error) {
	var mensaje =
		error.response &&
		error.response.data.mensaje &&
		error.response.data.mensaje !== ''
			? error.response.data.mensaje
			: getMessageError(error.response ? error.response.status : 200);
	Notification(getTypeNotification(error, 'error'), mensaje);
	reject(error);
};

const thenResponseMessage = function(resolve, result) {
	const response = result;
	var mensaje =
		response &&
		response.data &&
		response.data.mensaje &&
		response.data.mensaje !== ''
			? response.data.mensaje
			: getMessageError(response ? response.status : 200);
	if (mensaje) Notification(getTypeNotification(result, 'success'), mensaje);
	resolve(result);
};

const finallyResponse = function() {
	NProgress.done();
};

base.interceptors.request.use(interceptorRequest, interceptorRequestError);
baseBlob.interceptors.request.use(interceptorRequest, interceptorRequestError);
baseFile.interceptors.request.use(interceptorRequest, interceptorRequestError);

const getMessageError = function(status) {
	switch (status) {
		case 400:
			return 'Error al consumir el servicio, el servidor no pudo interpretar su petición.';
		case 401:
			return 'Error al consumir el servicio, no cuenta con autorizacion para el consumo de este servicio.';
		case 403:
			return 'Error al consumir el servicio, no cuenta con permisos para el consumo de este servicio.';
		case 404:
			return 'Error al consumir el servicio, recurso no encontrado.';
		case 500:
			return 'Error al consumir el servicio, recursos con problemas internos.';
		case 501:
			return 'Error al consumir el servicio, no se ha encontrado el recurso.';
		case 503:
			return 'Error al consumir el servicio, el sistema está en mantenimiento.';
	}
};

const getTypeNotification = function(result, tipoDefault = 'error') {
	return result.response &&
		result.response.data.tipo &&
		result.response.data.tipo !== ''
		? result.response.data.tipo
		: tipoDefault;
};

export const Get = function(url, params = {}) {
	NProgress.start();
	return new Promise((resolve, reject) => {
		base
			.get(url, { params })
			.then((response) => thenResponseMessage(resolve, response))
			.catch((error) => catchErrorResponse(reject, error))
			.finally(finallyResponse);
	});
};

export const Post = function(url, params) {
	NProgress.start();
	return new Promise((resolve, reject) => {
		base
			.post(url, params)
			.then((response) => thenResponseMessage(resolve, response))
			.catch((error) => catchErrorResponse(reject, error))
			.finally(finallyResponse);
	});
};

export const Put = function(url, params) {
	NProgress.start();
	return new Promise((resolve, reject) => {
		base
			.put(url, params)
			.then((response) => thenResponseMessage(resolve, response))
			.catch((error) => catchErrorResponse(reject, error))
			.finally(finallyResponse);
	});
};

export const Delete = function(url, params) {
	NProgress.start();
	return new Promise((resolve, reject) => {
		base
			.delete(url, params)
			.then((response) => thenResponseMessage(resolve, response))
			.catch((error) => catchErrorResponse(reject, error))
			.finally(finallyResponse);
	});
};

export const PostBlob = function(url, params) {
	NProgress.start();
	return new Promise((resolve, reject) => {
		baseBlob
			.post(url, params)
			.then((response) => thenResponseMessage(resolve, response))
			.catch((error) => catchErrorResponse(reject, error))
			.finally(finallyResponse);
	});
};

export const PostFile = function(url, file, params = {}) {
	NProgress.start();
	return new Promise((resolve, reject) => {
		const formData = new FormData();
		formData.append('file', file);
		for (var val in params) formData.append(val, params[val]);
		baseFile
			.post(url, formData, {
				headers: {
					'content-type': `multipart/form-data; boundary=${formData._boundary}`
				}
			})
			.then((response) => thenResponseMessage(resolve, response))
			.catch((error) => catchErrorResponse(reject, error))
			.finally(finallyResponse);
	});
};

export default {
	Get,
	Post,
	PostBlob,
	PostFile,
	Delete,
	Put
};
